export default __webpack_public_path__ + "static/media/task_alt_black_24dp.9b5f51ad.svg";